import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './FailedBooking.css';
import cx from 'classnames';
import getFailedBookings from './getFailedBookings.graphql';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';

import BookingList from '../../../components/SiteAdmin/Booking/BookingList';
import Loader from '../../../components/Common/Loader/Loader';
import { parseBookingFilters, toBookingQueryVariables } from '../../../helpers/bookingListFilters';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

export class FailedBooking extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        filters: PropTypes.object
    }

    static defaultProps = {
        bookingDetails: {
            loading: true
        },
        filters: parseBookingFilters({})
    }

    state = {
        hasLoadedOnce: false
    }

    // The page loader covers the first load only. Once the list has had content
    // it stays mounted: unmounting it while a search is in flight would discard
    // the keyword and filters that live in its own state.
    static getDerivedStateFromProps(props, state) {
        if (!state.hasLoadedOnce && props.bookingDetails.getAllOrdersAdmin) {
            return { hasLoadedOnce: true };
        }
        return null;
    }

    render() {
        const { title, bookingDetails, bookingDetails: { loading }, filters } = this.props;
        const showLoader = loading && !this.state.hasLoadedOnce;

        return (
            <Loader type={"page"} show={showLoader}>
                <div className={s.root}>
                    <div className={s.container}>
                       <div className={cx(s.heading, 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.manageCancelledTrips} />
                        </div>
                        <div className={s.paddingRoutesSection}>
                            {
                                !showLoader && <BookingList
                                    bookingDetails={bookingDetails}
                                    requestType={'failed'}
                                    filters={filters}
                                />
                            }
                        </div>
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getFailedBookings, {
        name: 'bookingDetails',
        options: (props) => ({
            variables: toBookingQueryVariables(props.filters, 'failed'),
            fetchPolicy: 'cache-and-network'
        })
    })
)(FailedBooking);
